import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
            styleOverrides: {
                root: {
                    display: 'inline',
                    position: 'relative',
                    color: designTokens.color.shade.black.value,
                    fontSize: designTokens.typography.body.long1.size.value,
                    lineHeight: designTokens.typography.body.long1.lineHeight.value,
                    transform: 'none',
                    '&.Mui-focused': {
                        color: designTokens.color.shade.black.value,
                    },
                    '&.Mui-disabled': {
                        color: designTokens.color.shade.black.value,
                    },
                    '&.Mui-error': {
                        color: designTokens.color.shade.black.value,
                    },
                },
                asterisk: {
                    color: theme.palette.error.main,
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=inputLabelTheme.js.map